import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AddDriver from './AddDriver'; // adjust the path as needed

const AddDriverPage = ({ onCancel }: { onCancel: () => void }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <AddDriver onCancel={onCancel} />
    </LocalizationProvider>
  );
};

export default AddDriverPage;
